import {TipoRisorsa} from '../_models/generated/tipo-risorsa';
import {EnumUiMap} from "../_services/meta.service";

export const TIPO_RISORSA_UI: EnumUiMap = {
  [TipoRisorsa.TUTTO]: {bg: 'bg-orange-300', text: 'text-white'},
  [TipoRisorsa.PRODUZIONE]: {bg: 'bg-green-500', text: 'text-white'},
  [TipoRisorsa.QUALITA]: {bg: 'bg-violet-800', text: 'text-white', label: 'QUALITÀ'},
  [TipoRisorsa.BILANCE]: {bg: 'bg-amber-800', text: 'text-white'},
  [TipoRisorsa.CENTRO_DI_LAVORO]: {bg: 'bg-blue-800', text: 'text-white'},
  [TipoRisorsa.STAMPANTE]: {bg: 'bg-red-800', text: 'text-white'},
  [TipoRisorsa.RASPBERRY]: {bg: 'bg-gray-400', text: 'text-white'},
  [TipoRisorsa.MAGAZZINO]: {bg: 'bg-blue-400', text: 'text-white'},
  [TipoRisorsa.SERVIZIO_ESTERNO]: {bg: 'bg-teal-600', text: 'text-white', label: 'SERVIZIO ESTERNO'},
};
